import React, {useRef, useState,useEffect} from 'react';
import styles from './Players.module.scss';
import TinySlider from "tiny-slider-react";
import SliderControls from "./SliderButton"
import sliderStyles from './TinySlider.module.scss';
import { Context } from '../Store';

const Players = (props) => {
  const state = React.useContext(Context); 

  function getNumberWithOrdinal(n) {
    var s = ["th", "st", "nd", "rd"],
        v = n % 100;
    return (s[(v - 20) % 10] || s[v] || s[0]);
  }

  const noTeams = (state.teams.length === 0) ? true : false;
  const teamSliderRef = [];
  teamSliderRef[0] = useRef();
  teamSliderRef[1] = useRef();
  const playerSettings = [];
  let twoRowPlayers = false;

 for (let [i, team] of state.teams.entries()) {
  let playerCOunt = [...state.players].filter(player => {return player.team_id == team.id}).length;
  twoRowPlayers = (playerCOunt > 4) ? true : twoRowPlayers;
  playerSettings[i] = {
    lazyload: true,
    touch: true,
    nav: false,
    controlsContainer: '.'+styles.playersContainer + ' .sliderControls.multiSlider'+i,
    mouseDrag: true,
    loop: false,
    items: 2,
    gutter: 0,
    edgePadding: 0,
    responsive: {
      480:{
        items: 3,
      },
      640:{
        items: 2,
      },
      1024:{
        items: 3 ,
      },
      1248:{
        //items: 4 ,
        items: (playerCOunt < 4) ? playerCOunt : 4 ,
      }
    }
  }
 }
let tournamentSettings = {
  lazyload: true,
  touch: true,
  nav: false,
  controlsContainer: '.'+styles.playersContainer + ' .sliderControls.tournamentSliderControls',
  mouseDrag: true,
  loop: false,
  items: 1,
  gutter: 0,
  slideBy: 1,
  responsive: {
    640:{
      items: 2,
      edgePadding: 20,
    },
    1024:{
      items: 2 ,  
      edgePadding: 0,
    }
  }
}
let noTeamsSettings = {
  lazyload: true,
  touch: true,
  nav: false,
  controlsContainer: '.'+styles.playersContainer + ' .sliderControls.tournamentSliderControls',
  mouseDrag: true,
  loop: false,
  items: 2,
  gutter: 0,
  slideBy: 1,
  responsive: {
    640:{
      items: state.players.length < 4 ? state.players.length : 4,
      edgePadding: 20,
    },
    1024:{
      items: state.players.length < 8 ? state.players.length : 8 ,  
      edgePadding: 0,
    }
  }
}


// Helper function to get player photo
const getPlayerPhoto = (player) => {
  return player.photo 
    ? 'data:image/jpeg;base64, ' + player.photo 
    : player.gender === 'male' ? './img/boy.png' : './img/girl.png';
};

const Points = (props) => {
  return(
    <div className={`team_${props.teamColour} ${styles.points}`}><div className={styles.pointsHeight}></div>
      { !noTeams && 
        props.player.points
      }
      { noTeams && 
        (props.player.points * 2) + props.player.draws - props.player.losses
      }
    </div>
  )
}
const generatePlayerComponent = (player, teamColour, className = styles.playerItem) => {
  let playerPhoto = getPlayerPhoto(player);
  return(
    <div key={player.id} className={className} onClick={() => openLightbox(player.origIndex)}>
      <div className={styles.player}>
        <div className={`team_${teamColour} ${styles.playerImage}`}>
          <img src={playerPhoto} alt="" /> 
        </div>
        <Points player={player} teamColour={teamColour} />
      </div>
      <div className={styles.playerName}>
      {player.name.toLowerCase()}
      </div>
    </div>
  )
}

  let teams = [];

  if(state.teams.length > 2){
    teams = [...state.teams].sort((a,b) => b.finalist - a.finalist || a.final_result - b.final_result || b.points - a.points).map((team, index) => {
      let teamColour = (team.colour == 1 ) ? 'blue' : 'pink'
      let teamPlayerArray = [...state.players].filter((player, origIndex) => {player.origIndex = origIndex; return player.team_id == team.id});
      let teamPlayers = teamPlayerArray.sort((a,b) => b.points - a.points).map((player, index) => {
        let teamLength = (twoRowPlayers) ? 'players_'+teamPlayerArray.length : 'onerow'
        return (
          generatePlayerComponent(player, teamColour, [styles.playerItem, styles[teamLength]].join(' '))
        )
      })
      if(teamPlayers.length > 0){
          return (
            <div  key={team.id} className={`team_${teamColour} ${styles.tournamentTeam}`}>
              <div key={index} className={styles.teamTitle}>
                <div className={`team_${team.name.toLowerCase()} ${styles.teamName}`} >{team.name.toUpperCase()}</div>
                <div className={`team_${team.name.toLowerCase()} ${styles.teamPoints}`}>{team.points}</div>
              </div>
              <div className={styles.teamPlayers}>
                  {teamPlayers}
              </div>
            </div>
          )        
      }else{
        return (false);
      }
    })

  }else if(state.teams.length > 0){
    teams = [...state.teams].map((team, index) => {
      let teamPlayers = [...state.players].filter((player, origIndex) => {player.origIndex = origIndex;return player.team_id == team.id}
      ).sort((a,b) => b.points - a.points).map((player, index) => {
        let teamColour = (['pink', 'blue'].includes(team.name.toLowerCase())) ? team.name.toLowerCase() : (team.colour == 1 ) ? 'blue' : 'pink';
        return (
          generatePlayerComponent(player, teamColour)
        )
      })
      if(teamPlayers.length > 0){
          return (
            // <div  key={team.id} className={styles.teamItem}>
              <div key={team.id} className={styles.playerSlider}>
                <SliderControls slider={teamSliderRef[index]} additionalClass={'multiSlider'+index}></SliderControls>
                <TinySlider settings={playerSettings[index]} ref={teamSliderRef[index]}>
                  {teamPlayers}
                </TinySlider>
              </div>
            // </div>
          ) 
      }else{
        return (false);
      }
    })
  }else{
    teams = [...state.players].map((player, index) => {player.origIndex = index; return player;}
    ).sort((a,b) => ((b.points * 2) + b.draws - b.losses) - ((a.points * 2) + a.draws - a.losses)
    ).map((player, index) => {
      return (
        generatePlayerComponent(player, 'purple')
      )
    });
  }

 


  let TeamPoints = () => {
    let points = [];
    state.teams.map((team, index) => {
      let teamColour = (['pink', 'blue'].includes(team.name.toLowerCase())) ? team.name.toLowerCase() : (team.colour == 1 ) ? 'blue' : 'pink';
      points.push(
        <div key={index} className={styles.teamTitle}>
          <div className={`team_${teamColour} ${styles.teamName}`} >{team.name.toUpperCase()}</div>
          <div className={`team_${teamColour} ${styles.teamPoints}`}>{team.points}</div>
        </div>
      )
    })
    return points;
  }

  const PlayerView = () => {
    let playerView;
    if(state.teams.length > 2 || state.teams.length === 0){
      playerView = 
      <div className={styles.tournamentSlider}>
        <SliderControls slider={teamSliderRef[0]} additionalClass={'tournamentSliderControls'}></SliderControls>
        <TinySlider settings={(noTeams) ? noTeamsSettings : tournamentSettings} ref={teamSliderRef[0]}>
          {teams}
        </TinySlider>
      </div>
      
    }else{
      playerView = 
      <div className={styles.playerSliderContainer}>
        {teams}
      </div> ;
    }
    return playerView;

  }

  let playerPhotoSources = state.players.map(player => {
    return  'data:image/jpeg;base64,'  + player.photo;
  }); 
  let playerPhotoMedia = state.players.map(player => {
    return {
      mediaType: 'PHOTO',
      mediaShare: state.guid +  '&player=' + player.id,
      mediaURI: 'data:image/jpeg;base64,'  + player.photo,
      sectionName: 'Player Photo'
    };
  });

  const openLightbox = (index) => {
    let lightboxDetails = {
      section: 'Players',
      index: index, 
      sources: playerPhotoSources,
      mediashare: playerPhotoMedia,
      type:"image"
    }
    props.openLightbox(lightboxDetails);
  }


  //let playerView = teams ;
  let stylesSection = (noTeams) ? 'team_section no_teams' : (state.teams.length < 3) ? 'teams_section player_slider_section' : 'teams_section'  ;

  return (
    <div className={`section ${stylesSection}`}>
      { state.teams.length > 2  &&
        <h2>TEAMS</h2>
      }
      {noTeams  &&
        <h2>LEADERBOARD</h2>
      }
      <div className="">
        { state.teams.length < 3  &&
          <div className={styles.pointsContainer}>
            <TeamPoints/>
          </div>
        }
        <div className={styles.playersContainer}>
          <PlayerView/>
        </div>
      </div>
    </div>
  )
}

export default Players;